module.exports = __webpack_public_path__ + "static/media/Leadership-banner.68e56f16.jpg";